module.exports = __webpack_public_path__ + "img/pnp_radio.01c28ada.png";